/**
 * Gift Catalogue logic controller
 *
 * @module component/gift_catalogue/logic/controller
 */

// Third-party imports
import $ from 'jquery';

// Local imports
import {
    buttonStateHandler,
    updateAddGiftButtonLabel,
} from './button_handler.js';
import { getCartProducts } from './cart.js';
import { injectVariantIDCartButton } from './page_handler.js';
import * as motcode_handler from './motcode_handler.js';
import * as quantity_handler from './quantity_handler.js';
import { userSelectionEventInitializer } from './select_handler.js';
import * as currency from '../../util/currency.js';

// Module name
export const MODULE_NAME = 'gclogic';

export let global_vars = {};

/**
 * Initialize all controller logic
 * @param {Window} global - The global object (window in browser context)
 */
export function initialize(global) {
    updateAddGiftButtonLabel();

    let variants = $('.js-giftCataloguePriceVariants-wrapper').find(
        '.js-giftCataloguePriceVariants'
    );
    if (variants.length === 0) {
        return;
    }
    let variantsArray = buildVariantDataArray(variants);
    let numberOfVariants = $('.js-numberOfVariants-hook').data(
        'variantquantity'
    );
    let productsInCartArray = [];
    resetVariantID();
    uncheckAllVariants();
    quantity_handler.setButtonStateQuantityClickEvent();
    motcode_handler.initialize(global);
    getCartProducts(variantsArray, productsInCartArray);
    checkForProductOptions(global, {
        variantsArray,
        numberOfVariants,
        productsInCartArray,
    });
    initializeFirstVariantIfApplies(variantsArray);

    // Reformat all variant prices
    format_variant_price(global);
}

function format_variant_price(global) {
    let doc = global.document;
    let selector = 'span.js-variant-price';
    let all_prices = doc.querySelectorAll(selector);
    let in_cents = false;
    for (let price_elem of all_prices) {
        let with_symbol = true;

        let price_str = currency.clean(price_elem.textContent);
        price_elem.textContent = currency.format(
            price_str,
            in_cents,
            with_symbol
        );
    }
}

function resetVariantID() {
    $('.js-variantID-hook').val('');
}

function uncheckAllVariants() {
    $('.js-variant-hook').prop('checked', false);
}

async function initializeFirstVariantIfApplies(variantsArray) {
    $('.js-variant-check-first').prop('checked', true);
    // Only set quantity to 1 if there's stock available
    if (variantsArray.length !== 0 && variantsArray[0].variantQuantity !== 0) {
        quantity_handler.resetQuantityCounter();
    }
    if (variantsArray.length > 0) {
        injectVariantIDCartButton(variantsArray[0].variantid);
        if (
            variantsArray[0].isMerchandise &&
            variantsArray[0].inventoryTracked
        ) {
            quantity_handler.injectVariantMaxQuantityData(
                variantsArray[0].variantQuantity
            );
        } else {
            quantity_handler.injectVariantMaxQuantityData('doesNotApply');
        }
    }
    buttonStateHandler();
}

function buildVariantDataArray(variants) {
    let dataArray = [];
    for (let i = 0; i < variants.length; i++) {
        let el = $(variants[i]);
        let data = el.data();
        if (typeof data !== 'undefined') {
            dataArray.push(data);
        }
    }
    return dataArray;
}

function checkForProductOptions(global, args) {
    if (hasZeroVariant(args)) {
        initializeZeroProductOption(args.variantsArray);
    } else {
        initializeOneOrMoreProductOptions(global, args);
    }
}

function hasZeroVariant(args) {
    let variant_arr = args.variantsArray;
    if (variant_arr.length === 0) {
        return true;
    }

    // let variant = variant_arr[0];
    let title = variant_arr[0].title;
    if (typeof title === 'undefined' || title === 'Default Title') {
        return true;
    }
}

// Called on products without variants
function initializeZeroProductOption(variantsArray) {
    if (variantsArray.length !== 0) {
        injectVariantIDCartButton(variantsArray[0].variantid);
        quantity_handler.quantityHandler(variantsArray[0]);
        buttonStateHandler();
    }
}

function initializeOneOrMoreProductOptions(global, args) {
    buttonStateHandler();
    userSelectionEventInitializer(global, args);
}
